import { FaCheckCircle, FaCompass, FaHeart, FaShieldAlt, FaUsers } from 'react-icons/fa';

const values = [
  {
    title: 'Compassion First',
    text: 'We treat every participant and family with empathy, patience, and respect.',
    icon: FaHeart,
  },
  {
    title: 'Dignity and Independence',
    text: 'Our care approach protects autonomy while providing needed daily support.',
    icon: FaUsers,
  },
  {
    title: 'Compliance and Safety',
    text: 'We follow applicable federal, state, and local standards for participant safety.',
    icon: FaShieldAlt,
  },
  {
    title: 'Cultural Responsiveness',
    text: 'We support diverse communities with inclusive communication and care planning.',
    icon: FaCompass,
  },
];

export default function AboutPage() {
  return (
    <>
      <section className="relative overflow-hidden bg-gradient-to-r from-teal-800 to-cyan-800 py-16 text-white">
        <div className="pointer-events-none absolute -left-20 top-10 h-60 w-60 rounded-full bg-cyan-300/20 blur-3xl" />
        <div className="pointer-events-none absolute -right-20 bottom-8 h-60 w-60 rounded-full bg-teal-300/20 blur-3xl" />
        <div className="mero-wrapper">
          <p className="text-sm font-semibold uppercase tracking-[0.2em] text-teal-100">
            About Golden Hands
          </p>
          <h1 className="mt-3 text-4xl font-bold tracking-tight">
            A trusted partner for home care in Pennsylvania
          </h1>
          <p className="mt-5 max-w-4xl text-teal-50">
            Golden Hands Home Care was founded to serve families seeking
            dependable in-home support for eligible participants. We focus on
            safety, continuity of care, and meaningful relationships with every
            participant we support.
          </p>
        </div>
      </section>

      <section className="py-16">
        <div className="mero-wrapper grid gap-8 lg:grid-cols-[1.2fr_0.8fr]">
          <article className="rounded-2xl border border-slate-200 bg-white p-7 shadow-sm">
            <h2 className="text-2xl font-bold text-slate-900">Our Vision</h2>
            <p className="mt-4 leading-7 text-slate-600">
              To be the home care provider of choice for seniors and eligible
              adults with disabilities, helping each participant achieve the
              highest possible quality of life while remaining independent at
              home.
            </p>

            <h2 className="mt-8 text-2xl font-bold text-slate-900">Our Mission</h2>
            <p className="mt-4 leading-7 text-slate-600">
              We deliver compassionate, participant-centered home care services
              that strengthen families, improve daily well-being, and support
              long-term stability for every eligible person we serve.
            </p>
          </article>

          <aside className="rounded-2xl border border-slate-200 bg-slate-100 p-7">
            <h3 className="text-xl font-bold text-slate-900">Why families choose us</h3>
            <ul className="mt-5 space-y-4 text-sm text-slate-700">
              <li className="flex items-start gap-3">
                <FaCheckCircle className="mt-1 text-teal-700" />
                Care plans tailored to participant assessments and goals
              </li>
              <li className="flex items-start gap-3">
                <FaCheckCircle className="mt-1 text-teal-700" />
                Dependable caregivers with strong communication
              </li>
              <li className="flex items-start gap-3">
                <FaCheckCircle className="mt-1 text-teal-700" />
                Support for referral, onboarding, and care coordination
              </li>
              <li className="flex items-start gap-3">
                <FaCheckCircle className="mt-1 text-teal-700" />
                Respectful service in every home and community
              </li>
            </ul>
          </aside>
        </div>
      </section>

      <section className="bg-white py-16">
        <div className="mero-wrapper">
          <h2 className="text-2xl font-bold text-slate-900">Our Core Values</h2>
          <div className="mt-8 grid gap-5 md:grid-cols-2">
            {values.map((value) => {
              const Icon = value.icon;

              return (
              <article
                key={value.title}
                className="group rounded-2xl border border-slate-200 bg-slate-50 p-6 transition hover:-translate-y-1 hover:shadow-md"
              >
                <span className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-teal-100 text-teal-700 transition group-hover:bg-teal-700 group-hover:text-white">
                  <Icon />
                </span>
                <h3 className="text-lg font-semibold text-teal-800">{value.title}</h3>
                <p className="mt-2 text-sm text-slate-600">{value.text}</p>
              </article>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
}
